<template>
  <div class="scroll-to-top" @click="scrollToTop">
    <img src="../assets/img/arrow.svg" title="Przewiń do początku" alt="scroll to top" />
  </div>
</template>

<script>
export default {
  name: "ScrollToTop",
  methods: {
    scrollToTop: function() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss">
.scroll-to-top {
  position: absolute;
  bottom: 60px;
  left: $main-gutter-left;
  cursor: pointer;

  img {
    transform: rotate(-90deg);
    width: 34px;

    &:hover {
      transform: rotate(-120deg);
    }
  }
}
</style>